import React from 'react'
import minus from '../../assets/img/icon/minus-circle.png'
import plus from '../../assets/img/icon/plus-circle.png'

const QuestionDetail = ({ question, answer, isOpen, onToggle }) => {
  return (
    <div className='ml-5 cursor-pointer overflow-auto mobile:ml-0 w-[92%] mobile:w-[95%]  '>
      {/* Question Section */}
      <div
        onClick={onToggle}
        className='flex items-center justify-between font-semibold text-m text-[#101828] py-4'
      >
        <span className=' text-[16px] mobile:text-[14px] w-[92%] mobile:w-[90%]'>
          {question}
        </span>
        <img
          src={isOpen ? minus : plus}
          className='h-[24px] w-[24px]'
          alt='Toggle Icon'
        />
      </div>

      {/* Answer Section */}
      {isOpen && (
        <div className='text-[14px] text-[#475467] mb-5 mobile:text-[12px] w-[95%] mobile:w-[90%] text-justify'>
          <p> {answer.main}</p>
          <ul>
            {answer.list &&
              answer.list.map((item, index) => (
                <li className='ml-2 mt-2 text-[12px]'>{item}</li>
              ))}
          </ul>
          <p> {answer.main2}</p>
          <ul>
            {answer.list2 &&
              answer.list2.map((item, index) => (
                <li className='ml-2 mt-2 text-[12px]'>{item}</li>
              ))}
          </ul>
          <p> {answer.main3}</p>
          <ul>
            {answer.list3 &&
              answer.list3.map((item, index) => (
                <li className='ml-2 mt-2 text-[12px]'>{item}</li>
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default QuestionDetail
